import { Text } from 'preact-i18n';

const WidgetTitle = ({ copy }) => {
  return (
    <h2 className="reservamos-search-title"><Text id={`title.${copy}`} /></h2>
  );
};

export default WidgetTitle;
